import * as R from 'ramda';
//
import { isNullUndefinedOrEmptyString } from './poor-js';
//////////////////////////////////////////////////

// NOTE: add all common functional helpers here

const notEquals = R.complement(R.equals);
const notPropEq = R.complement(R.propEq);
const isNaN = R.equals(NaN);
const isTrue = R.equals(true);
const isNotNaN = notEquals(NaN);
const isNot = R.complement(R.is);
const notHas = R.complement(R.has);
const mapIndexed = R.addIndex(R.map);
const isNotNil = R.complement(R.isNil);
const isNotEmpty = R.complement(R.isEmpty);
const filterIndexed = R.addIndex(R.filter);
const notContain = R.complement(R.includes);
const findMatching = R.compose(R.find, R.where);
const isZero = (value) => R.equals(value, 0);
const isNotZero = (value) => notEquals(value, 0);
const isFalse = (value) => R.equals(value, false);
const isAllTrue = (...arg) => R.all(isTrue, arg);
const isAnyTrue = (...arg) => R.any(isTrue, arg);
const isAllFalse = (...arg) => R.all(isFalse, arg);
const isAnyFalse = (...arg) => R.any(isFalse, arg);
const isNilOrZero = (value) => R.or(R.isNil(value), isZero(value));
const isNilOrFalse = (value) => R.or(R.isNil(value), isFalse(value));
const isNilOrEmpty = (value) => R.or(R.isNil(value), R.isEmpty(value));
const isEmptyOrFalse = (value) => R.or(R.isEmpty(value), isFalse(value));
const isNotNilAndNotZero = (value) => R.and(isNotNil(value), isNotZero(value));
const isNotNilAndNotEmpty = (value) => R.and(isNotNil(value), isNotEmpty(value));

const isPathNotNilAndNotEmpty = R.curry((path, value) => R.and(
  isNotNil(R.path(path, value)),
  isNotEmpty(R.path(path, value)),
));

const isAllNilOrEmpty = R.all(isNilOrEmpty);
const isAnyNilOrEmpty = R.any(isNilOrEmpty);
const isAllNotNilOrNotEmpty = R.all(isNotNilAndNotEmpty);
const isOneNotNilOrNotEmpty = R.any(isNotNilAndNotEmpty);

const mergeWithoutNullUndefinedOrEmptyString =
  R.mergeWith((a, b) => (isNullUndefinedOrEmptyString(b) ? a : b));

const mergeWithoutOneFieldNullUndefinedOrEmptyString = (fieldName, left, right) => {
  const result = R.mergeRight(left, right);

  const resultFieldValue = R.prop(fieldName, result);

  if (isNotNilAndNotEmpty(resultFieldValue)) return result;

  const leftFieldValue = R.prop(fieldName, left);

  return R.assoc(fieldName, leftFieldValue, result);
};

const isArray = R.is(Array);
const isObject = R.is(Object);
const isString = R.is(String);
const isNumber = R.is(Number);
const isBoolean = R.is(Boolean);
const isJestMockFn = (fn) => isTrue(R.path(['_isMockFunction'], fn));
const isFunction = (fn) => R.or(R.is(Function, fn), isJestMockFn(fn));

// falsy - null, undefined, 0, '', NaN, false
const isFalsy = (value) => isFalse(Boolean(value));

const isFirstItemArray = R.pathSatisfies(R.is(Array), [0]);
const isFirstItemString = R.pathSatisfies(R.is(String), [0]);
const isFirstItemObject = R.pathSatisfies(R.is(Object), [0]);

const isArrayOfStrings = R.allPass([isArray, isNotEmpty, R.all(isString)]);

const sortByIndex = R.sortBy(R.prop('index'));
const sortByProp = (propName) => R.sortBy(R.prop(propName));
const indexByGuid = (items) => R.indexBy(R.prop('guid'), items);
const indexByValue = (items) => R.indexBy(R.prop('value'), items);

const callFunction = (func) => {
  if (isJestMockFn(func)) return func();

  if (isFunction(func)) func();
};

const callFunctionWithArgs = (func, args) => {
  if (isFunction(func)) func(args);
};

const callFunctionWith2Args = (func, args1, args2) => {
  if (isFunction(func)) func(args1, args2);
};

const callFunctionTwice = (func) => {
  callFunction(func);
  callFunction(func);
};

const getOrElse = (obj, prop, elseSt) => {
  if ((isNotNil(obj) && isNotNil(obj[prop]))) return obj[prop];

  return elseSt;
};

const ifElse = (predicate, ifSt, elseSt) => {
  if (predicate) return ifSt;

  return elseSt;
};

const assign = (...args) => Object.assign({}, ...args);

export {
  isNot,
  isNaN,
  assign,
  isTrue,
  notHas,
  isZero,
  ifElse,
  isFalsy,
  isFalse,
  isArray,
  isNotNaN,
  isNotNil,
  isObject,
  isString,
  isNumber,
  getOrElse,
  notEquals,
  isNotZero,
  isAllTrue,
  isAnyTrue,
  isBoolean,
  notPropEq,
  mapIndexed,
  notContain,
  isAllFalse,
  isFunction,
  sortByProp,
  isAnyFalse,
  isNotEmpty,
  sortByIndex,
  isNilOrZero,
  indexByGuid,
  findMatching,
  indexByValue,
  isJestMockFn,
  isNilOrEmpty,
  callFunction,
  isNilOrFalse,
  filterIndexed,
  isEmptyOrFalse,
  isAnyNilOrEmpty,
  isAllNilOrEmpty,
  isArrayOfStrings,
  isFirstItemArray,
  isFirstItemString,
  isFirstItemObject,
  callFunctionTwice,
  isNotNilAndNotZero,
  isNotNilAndNotEmpty,
  callFunctionWithArgs,
  isAllNotNilOrNotEmpty,
  isOneNotNilOrNotEmpty,
  callFunctionWith2Args,
  isPathNotNilAndNotEmpty,
  mergeWithoutNullUndefinedOrEmptyString,
  mergeWithoutOneFieldNullUndefinedOrEmptyString,
};
